class Input {
    constructor(domElement) {
        this.domElement = domElement;
        this.input = this.domElement.querySelector('input');
        this.buttonShowPassword = this.domElement.querySelector('.input__password-button');
        this.#init();
    }

    #init() {
        if(this.input.type === 'password') {
            this.buttonShowPassword.addEventListener('click', () => this.toggleVisiblePassword());
        }
    }

    toggleVisiblePassword() {
        this.domElement.classList.toggle('input--show-password');
        if(this.domElement.classList.contains('input--show-password')) {
            this.input.type = 'text';
        }
        else {
            this.input.type = 'password';
        }
    }
}

const inputs = document.querySelectorAll('.input');
inputs.forEach(input => {
    new Input(input);
})